const BENEFITS = [{
  level: '데브라',
  benefits: [
    '나만의 위성(CONTEC Satracer) 계정 등록',
    '컨텍 캐릭터인형(3종) 및 기념품 1회 제공',
    '우주강의(3년 내) 참관 1회 제공',
    '지상국 안테나 & 위성 크리스탈 기념품 1회 제공',
    '세계 랜드마크 위성영상 액자(A3) 1회 제공',
    '컨텍크리에이티브 2기 해외 견학 행사 참가우대 (경비 본인부담)',
  ],
},
  {
    level: '메테',
    benefits: [
      '나만의 위성(CONTEC Satracer) 계정 등록',
      '컨텍 캐릭터인형(3종) 및 기념품 1회 제공',
    ],
  },
  {
    level: '코롱이',
    benefits: [
      '나만의 위성(CONTEC Satracer) 계정 등록',
      '컨텍 캐릭터인형(3종) 및 기념품 1회 제공',
      '우주강의(3년 내) 참관 1회 제공',
      '지상국 안테나 & 위성 크리스탈 기념품 1회 제공',
      '세계 랜드마크 위성영상 액자(A3) 1회 제공',
    ],
  }];

export default BENEFITS;